module.exports = __webpack_public_path__ + "img/wami_logo.7c3c702d.png";